import moment from 'moment';
import { TGuildEncounterSummary } from '../../../../../shared/types/guildTypes';
import { TRaidEncounterSummary } from '../../../../../shared/types/raidTypes';
import { RAID_METADATA } from '../../../../../shared/enums';

export function sortByFirstDefeated(a: TGuildEncounterSummary, b: TGuildEncounterSummary): number {
  const diff = moment.utc(a.firstDefeated).diff(moment.utc(b.firstDefeated));
  if (diff === 0) {
    if (a.slug === b.slug) {
      return 0;
    } else if (a.slug < b.slug) {
      return -1;
    }
    return 1;
  }
  return diff;
}

export function isDetailedKillRegion(slug: string) {
  return slug !== 'cn';
}

export function getRegionalRaidStartDate(regionSlug: string, raidSlug: string) {
  const metaData = RAID_METADATA.find((r) => r.slug === raidSlug);
  if (metaData) {
    return metaData.starts[regionSlug];
  }
  return null;
}

export function lookupEncounter(encounters: TRaidEncounterSummary[], slug: string): TRaidEncounterSummary {
  const matchedEncounters = encounters.filter((enc) => enc.slug === slug);
  if (matchedEncounters.length === 0) {
    return {
      encounterId: 0,
      slug,
      ordinal: 0,
      wingId: 0,
      name: 'Unknown',
      iconUrl: ''
    };
  }
  return matchedEncounters[0];
}

export function formatRealmName(region: any, realm: any) {
  if (region.slug === 'cn') {
    return realm.altName || realm.name;
  }
  return realm.name;
}
